import { ReactNode } from 'react'
import { useField } from 'formik'
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
} from '@ritualco/jutsu'

export type FormikCurrencyInputProps = {
  label?: ReactNode
  name: string
  isDisabled?: boolean
  isRequired?: boolean
} & InputProps

export const FormikCurrencyInput = ({
  label,
  isDisabled = false,
  isRequired = false,
  ...props
}: FormikCurrencyInputProps) => {
  const [field, { error, touched }] = useField(props.name)

  return (
    <FormControl
      id={props.name}
      isInvalid={!!error && touched}
      isDisabled={isDisabled}
      isRequired={isRequired}
    >
      {label && <FormLabel>{label}</FormLabel>}
      <InputGroup>
        <InputLeftElement
          pointerEvents="none"
          color="grayscale.tertiary"
          h={12}
          fontSize="medium"
          children="$"
        />
        <Input size="lg" {...field} {...props} />
      </InputGroup>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  )
}
